import { CustomAuthErrorCodes } from '../config/constants';

export function parseCustomErrorCode(errorMessage: string): string | undefined {
  if (!errorMessage) {
    return undefined;
  }

  const customErrorPattern = /AAD_Custom_\d{4}/;
  const match = errorMessage.match(customErrorPattern);

  if (!match) {
    return undefined;
  }

  const extractedCode = match[0];

  const isValidCode = Object.values(CustomAuthErrorCodes).includes(
    extractedCode as CustomAuthErrorCodes,
  );

  return isValidCode ? extractedCode : CustomAuthErrorCodes.UnknownError;
}
